import { useMemo } from 'react';
import { useAppSelector } from 'src/redux/hook';
import { PERMISSIONS } from 'src/shared/constants/permission';

/**
 * Hook to check user permissions
 * @returns Object with permission checking functions
 */
export const usePermission = () => {
  const { masterData } = useAppSelector((state) => state.global);
  const pms = masterData?.pms || [];

  const hasPermission = useMemo(() => {
    return (permissionCode: string): boolean => {
      if (!pms || pms.length === 0) return false;

      const checkNode = (nodes: any[]): boolean => {
        for (const node of nodes) {
          if (node.code === permissionCode && node.enable) {
            return true;
          }
          if (node.child && node.child.length > 0) {
            if (checkNode(node.child)) {
              return true;
            }
          }
        }
        return false;
      };

      return checkNode(pms);
    };
  }, [pms]);

  const hasAnyPermission = useMemo(() => {
    return (...permissionCodes: string[]): boolean => {
      return permissionCodes.some((code) => hasPermission(code));
    };
  }, [hasPermission]);

  const hasAllPermissions = useMemo(() => {
    return (...permissionCodes: string[]): boolean => {
      return permissionCodes.every((code) => hasPermission(code));
    };
  }, [hasPermission]);

  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    PERMISSIONS,
  };
};
